export const patients = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'patients' })) } return false } })() },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── HEADER ────────────────────────────
      PageHeader: {
        flow: 'x', align: 'center space-between', marginBottom: 'Z',
        '@mobileL': { flow: 'y', gap: 'Z' },
        TitleWrap: {
          flow: 'y', gap: 'Y',
          PageTitle: { tag: 'h1', text: '{{ navPatients | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },
          PageSubtitle: { text: '24 total patients', fontSize: 'Z', color: 'inkMuted' }
        },
        AddPatientBtn: {
          tag: 'button', text: '{{ addPatient | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'A',
          background: 'inkText', color: 'inkMid', border: 'none', cursor: 'pointer',
          transition: 'opacity 150ms ease', ':hover': { opacity: '0.8' }
        }
      },

      // ─── SEARCH & FILTERS ─────────────────
      SearchRow: {
        flow: 'x', gap: 'Z', align: 'center', marginBottom: 'Z',
        '@mobileL': { flow: 'y' },
        SearchInput: {
          tag: 'input', type: 'text', placeholder: 'Search patients by name, phone, or ID...',
          flex: '1', padding: 'Z A', round: 'A', background: 'inkSurface',
          color: 'inkText', border: '1px solid inkBorder', fontSize: 'Z',
          outline: 'none', transition: 'border 150ms ease',
          ':focus': { border: '1px solid teal' }
        },
        FilterBtns: {
          flow: 'x', gap: 'Y', flexShrink: '0',
          AllBtn: { tag: 'button', text: '{{ all | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkText', color: 'inkMid', border: 'none', cursor: 'pointer' },
          ActiveBtn: { tag: 'button', text: '{{ active | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'transparent', color: 'inkMuted', border: '1px solid inkBorder', cursor: 'pointer' },
          NewBtn: { tag: 'button', text: '{{ new | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'transparent', color: 'inkMuted', border: '1px solid inkBorder', cursor: 'pointer' }
        }
      },

      // ─── PATIENTS TABLE ───────────────────
      PatientsTable: {
        flow: 'y', round: 'A', background: 'inkMid', border: '1px solid inkBorder', overflow: 'hidden',

        TableHeader: {
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', background: 'inkSurface',
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          ColName: { text: '{{ patient | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
          ColPhone: { text: '{{ phone2 | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
          ColLastVisit: { text: '{{ lastVisit | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
          ColNextAppt: { text: '{{ nextAppt | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em', '@tabletS': { display: 'none' } },
          ColBalance: { text: '{{ balance | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em', '@tabletS': { display: 'none' } },
          ColAction: { text: '', fontSize: 'Y' }
        },

        Row1: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'GB', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ giorgiBeridze | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt001 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 11 22', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Mar 10', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: 'Mar 19', fontSize: 'Z', color: 'teal', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾0', fontSize: 'Z', color: 'green', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        },

        Row2: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'NK', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ ninoKapanadze | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt002 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 33 44', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Mar 5', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: 'Mar 21', fontSize: 'Z', color: 'teal', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾350', fontSize: 'Z', color: 'amber', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        },

        Row3: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'DG', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ davitGelashvili | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt003 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 55 66', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Feb 28', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: 'Mar 25', fontSize: 'Z', color: 'teal', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾1,200', fontSize: 'Z', color: 'red', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        },

        Row4: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'MT', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ mariamTsiklauri | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt004 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 77 88', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Mar 12', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: '-', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾0', fontSize: 'Z', color: 'green', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        },

        Row5: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'AJ', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ anaJavakhishvili | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt005 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 99 00', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Mar 8', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: 'Mar 22', fontSize: 'Z', color: 'teal', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾180', fontSize: 'Z', color: 'amber', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        },

        Row6: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', borderBottom: '1px solid inkBorder', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'LM', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ lukaMchedlishvili | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt006 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 12 34', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Mar 15', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: 'Apr 2', fontSize: 'Z', color: 'teal', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾0', fontSize: 'Z', color: 'green', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        },

        Row7: {
          tag: 'a', href: '/patient', textDecoration: 'none', color: 'inkText',
          display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 80px',
          padding: 'Z A', cursor: 'pointer',
          transition: 'background 150ms ease', ':hover': { background: 'inkSurface' },
          '@tabletS': { gridTemplateColumns: '2fr 1fr 1fr 80px' },
          CellName: {
            flow: 'x', gap: 'Z', align: 'center',
            Avatar: { width: 'B', height: 'B', round: 'E', background: '#0D1117', color: '#FFFFFF', fontWeight: '600', fontSize: 'Y', flow: 'x', align: 'center center', text: 'TL', flexShrink: '0' },
            NameWrap: { flow: 'y', gap: 'X', Name: { text: '{{ tamtaLomidze | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, Id: { text: '{{ pt007 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
          },
          CellPhone: { text: '+995 555 56 78', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellLastVisit: { text: 'Mar 1', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x' },
          CellNext: { text: '-', fontSize: 'Z', color: 'inkMuted', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellBalance: { text: '₾500', fontSize: 'Z', color: 'red', fontWeight: '500', align: 'center flex-start', flow: 'x', '@tabletS': { display: 'none' } },
          CellAction: { text: '→', fontSize: 'Z', color: 'inkMuted', align: 'center center', flow: 'x' }
        }
      }
    },
    MobileTabBar: {}
  }
}
